module.exports = __webpack_public_path__ + "img/u2.a863f51b.jpg";